module.exports = __webpack_public_path__ + "img/2d4ab02.jpg";